/* Chi ha portato questo cliente in archivio, detto in italiano.

   Nasce da una richiesta precisa: i clienti creati dalla verifica dominio di un agente
   (il primo e' stato «Enterprise Srl», 07/10/2026) non dicevano CHI li aveva creati. Sul
   record c'era solo «dominio_origine: agente» — l'agente in carne e ossa non si sapeva. */

const VIE = {
  dominio: 'verifica dominio',
  campagna: 'campagna',
  indaga: 'ricerca Indaga',
  vicine: 'aziende vicine',
};

const CHI = {
  agente: 'un agente',
  pubblico: 'un collaboratore esterno',
  staff: 'lo staff',
  sistema: 'il sistema',
};

/* Il nome da mostrare: quello scritto per esteso se c'e', altrimenti lo username, che per
   gli agenti e' comunque riconoscibile (sh00000281). */
export function autoreRecord(d) {
  const r = d || {};
  return (r.creato_da_nome || r.creato_da || r.imported_by || '').trim() || null;
}

/* Una frase sola: «Creato da Daniele (agente) con la verifica dominio il 7 ottobre 2026».
   Null quando non c'e' niente da dire, cosi' la scheda non mostra una riga vuota. */
export function frasiProvenienza(d) {
  const r = d || {};
  const via = VIE[r.fonte];
  const autore = autoreRecord(r);
  if (!via && !autore) return [];
  const chi = CHI[r.dominio_origine || r.origine_creazione];
  const fuori = [];
  if (autore) fuori.push(chi ? `${autore} (${chi})` : autore);
  else if (chi) fuori.push(chi.charAt(0).toUpperCase() + chi.slice(1));
  if (via) fuori.push(`dalla ${via}`);
  const quando = dataItaliana(r.imported_at);
  if (quando) fuori.push(`il ${quando}`);
  return fuori;
}

export function dataItaliana(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
}
